<div class="profile-icon-button">
  <ng-template #loadingUser>
    <mat-spinner mode="indeterminate" color="accent" [diameter]="iconSize" />
  </ng-template>

  <ng-container *ngIf="user$ | async as user; else loadingUser">
    <div>
      <pt-user-icon
        matRipple
        [name]="user.name"
        [src]="user | profileImage$ | async"
        [diameter]="iconSize"
        [matMenuTriggerFor]="accountMenu"
      />
      <mat-icon
        *ngIf="isManagementUser$ | async"
        class="management-user-icon"
        matTooltip="Management User"
        [matMenuTriggerFor]="accountMenu"
        >admin_panel_settings</mat-icon
      >
    </div>
    <mat-menu #accountMenu="matMenu">
      <ng-template matMenuContent>
        <pr-auth-user-card [user]="user" />
        <button
          mat-menu-item
          [matMenuTriggerFor]="changeUserMenu"
          [disabled]="disableChangeUser$ | async"
        >
          Change User
        </button>
        <mat-menu
          #changeUserMenu="matMenu"
          overlapTrigger
          class="no-padding wide"
        >
          <pr-switch-user-list />
        </mat-menu>

        <button
          *ngIf="hasWorkspaces$ | async"
          class="change-workspace"
          mat-menu-item
          (click)="changeWorkspace()"
        >
          <div class="flex flex-col py-2">
            <div class="font-medium">Change Workspace</div>
            <div class="text-xs">
              @if (organisation.organisation$ | async; as org) {
                <span>{{ org.name }}</span>
              }
              <span class="workspace-slug whitespace-nowrap text-slate-400">
                ({{ workspace.workspace$ | async }})
              </span>
            </div>
          </div>
        </button>

        <mat-nav-list dense>
          <ng-container *ngIf="organisation.staffer$ | async as staffer">
            <mat-divider />

            <div class="flex flex-col gap-2 px-4 py-2">
              <div class="text-xs font-bold opacity-50">My Profile</div>
            </div>
            <a mat-list-item [prBrandRouterLink]="['staff', staffer.ref.id]">
              Schedule
            </a>
            <a
              mat-list-item
              [prBrandRouterLink]="['staff', staffer.ref.id, 'treatment-plans']"
            >
              Treatment Plans
            </a>
          </ng-container>

          <a mat-list-item routerLink="/settings">Account Settings</a>

          @if (managementUser$ | async; as managementUser) {
            <mat-divider />
            <div class="flex flex-col gap-2 px-4 py-2">
              <div
                class="flex flex-row items-center gap-2 text-xs font-bold opacity-50"
              >
                <span class="flex grow">Management</span>
                <kbd
                  class="rounded border border-solid border-slate-300 bg-slate-100 px-1 text-slate-500"
                  >m</kbd
                >
              </div>
              <div
                class="flex cursor-pointer flex-row items-center"
                (click)="$event.stopPropagation(); managementSidebar.toggle()"
              >
                <div class="flex-1">Show Management Sidebar</div>
                <mat-slide-toggle
                  [checked]="managementSidebar.opened$ | async"
                  (click)="$event.stopPropagation()"
                  (change)="managementSidebar.toggle()"
                />
              </div>
              <div
                class="flex cursor-pointer flex-row items-center"
                (click)="
                  $event.stopPropagation(); managementSidebar.toggleDevTools()
                "
              >
                <div class="flex-1">Show Developer Tools</div>
                <mat-slide-toggle
                  [checked]="managementSidebar.showDevTools$ | async"
                  (click)="$event.stopPropagation()"
                  (change)="managementSidebar.toggleDevTools()"
                />
              </div>
            </div>
          }
          <mat-divider />

          <a mat-list-item (click)="auth.logout()">Sign Out</a>
        </mat-nav-list>
      </ng-template>
    </mat-menu>
  </ng-container>
</div>
